import { useId, useRef, type ReactNode } from 'react';
import { useModalFocus } from '../hooks/useModalFocus';
import { Icon } from './Icon';

interface ModalProps {
  open: boolean;
  title: string;
  description?: string;
  headerActions?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  width?: 'small' | 'medium' | 'large' | 'wide';
}

export function Modal({ open, title, description, headerActions, onClose, children, footer, width = 'medium' }: ModalProps) {
  const dialogRef = useRef<HTMLDivElement>(null);
  const titleId = useId();
  const descriptionId = useId();
  useModalFocus(dialogRef, open, onClose);

  if (!open) return null;
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className={`modal modal--${width}`} ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={description ? descriptionId : undefined} tabIndex={-1}>
        <div className="modal__header">
          <div className="modal__heading"><h2 id={titleId}>{title}</h2>{description && <p id={descriptionId}>{description}</p>}{headerActions && <div className="modal__header-actions">{headerActions}</div>}</div>
          <button type="button" className="icon-button" onClick={onClose} aria-label="Close dialog"><Icon name="close" /></button>
        </div>
        <div className="modal__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );
}
